import $ from "jquery";
import clear_tokens from "./clear_tokens.js";
import handle_error from "./handle_error.js";

function refresh_token(type, url, data, responseJSON, returnFunc) {
	if (url.includes("/user/user/") && responseJSON.code === "user_not_found") {
		clear_tokens();
		return false;
	}

	let refreshData = {};

	refreshData.refresh = "";
	if (localStorage.getItem("refresh_token")) {
		refreshData.refresh = localStorage.getItem("refresh_token");
	}

	refreshData = JSON.stringify(refreshData);

	// Revert data to JSON for POST and PUT requests
	if (type === "POST" || type === "PUT") {
		data = JSON.parse(data);
	}

	let refresh_url = "/user/token/refresh/";
	if (window.location.hostname === "localhost") {
		refresh_url = "http://localhost:8000" + refresh_url;
	}

	return $.ajax({
		type: "POST",
		url: refresh_url,
		contentType: "application/json",
		data: refreshData,
		statusCode: {
			401(_xhr) {
				clear_tokens();
			},
			500(_xhr) {
				clear_tokens();
			},
		},
		success(value) {
			localStorage.setItem("token", value.access);
			ajax_wrapper(type, url, data, returnFunc);
		},
		error(xhr, status, error) {
			handle_error(xhr, status, error);
			clear_tokens();
			// window.location.href = window.location.href;
		},
	});
}

export default refresh_token;
